import { DocumentTemplateType } from '../../../models/applications/application-documents';
import { Contract } from '../../../models/applications/contracts';
import { applicationDocumentsApi } from '../../../redux/api/applications/application-documents-api';
import { downloadFile } from '../../../utils/common';

export const useDownloadInvoiceDocument = () => {
  const [generateDocument] =
    applicationDocumentsApi.useLazyGenerateDocumentQuery();

  return (contract: Contract) => {
    generateDocument({
      id: Number(contract.id),
      docType: DocumentTemplateType.INVOICE,
    })
      ?.unwrap()
      .then(result => {
        downloadFile(
          new File(
            [result],
            'Счет на оплату договор_' + contract.number + '.docx'
          )
        );
      });
  };
};
